import {
  getComparator,
  getMetricName,
  getPreposition,
  getSuffix,
} from 'modules/campaigns/alerts/utils';
import { SCHEDULED_CAMPAIGN_TYPE_FILTERS } from 'modules/campaigns/lib/constants';
import { CampaignTypeFilter } from 'modules/domains/campaign';
import { MetricName } from '../../constants';
import { METRICS_TO_COMPARATORS } from '../constants';

export const sortByMetricName = (name1: MetricName, name2: MetricName) =>
  getMetricName(name1) < getMetricName(name2) ? -1 : 1;

export const getVerb = (valueType: string) => (valueType === 'number' ? 'are' : 'is');

export const generateAlertDisplayText = ({
  campaignType,
  metricName,
  valueType,
}: {
  campaignType: CampaignTypeFilter;
  metricName: MetricName;
  valueType: string;
}) => {
  const metricDisplayName = getMetricName(metricName);
  const verb = getVerb(valueType);
  const comparator = getComparator(METRICS_TO_COMPARATORS[metricName]);

  const isScheduled = SCHEDULED_CAMPAIGN_TYPE_FILTERS.includes(campaignType);
  const preposition = getPreposition(isScheduled);
  const suffix = getSuffix(campaignType);

  return { metricDisplayName, verb, comparator, preposition, suffix };
};
